import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["invitation"]

  trigger(event) {
    this.invitationOutlet.emailTarget.value = event.params.email
    this.invitationOutlet.nameTarget.value = event.params.name ? event.params.name : ""
    this.invitationOutlet.mobileNumberTarget.value = event.params.mobileNumber ? event.params.mobileNumber : ""
    this.invitationOutlet.farmNameTarget.value = event.params.farmName ? event.params.farmName : ""
  }
}
